import type { EstateAnalysis } from './analytics';

export type PointsOfInterest = NonNullable<
  EstateAnalysis['pointsOfInterest']
>['data']['items'][number];

export const usePointsOfInterest = (
  estateAnalysis: EstateAnalysis,
  radius: number
): {
  data: Record<string, PointsOfInterest[]>;
} => {
  const data = (estateAnalysis.pointsOfInterest?.data?.items || [])
    .sort((a, b) => {
      if (a.distance && b.distance) return a.distance > b.distance ? 1 : -1;
      if (a.distance) return 1;
      return -1;
    })
    .filter(({ distance }) => distance && distance <= radius)
    .reduce<Record<string, PointsOfInterest[]>>((acc, dt) => {
      if (!acc[dt.category]) {
        acc[dt.category] = [];
      }
      if (acc[dt.category].length < 5) {
        acc[dt.category].push(dt);
      }
      return acc;
    }, {});

  return { data };
};
